export default __webpack_public_path__ + "static/media/Price Review - 07082025.ee30d243.zip";